var map = {
	"./1.jpg": 2047,
	"./2.jpg": 4538,
	"./3.jpg": 2820,
	"./4.jpg": 7473,
	"./5.jpg": 3720,
	"./6.jpg": 2051,
	"./7.jpg": 8408,
	"./8.jpg": 2977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1118;